import apiHelpers from "../../../app/api/apiHelpers";
import { toastError, toastSuccess } from "../../../app/common/helpers/notificationsHelper";

export const confirmEmailResendHandler = (email: string) => {
    apiHelpers.account.resendEmail(email)
        .then(() => toastSuccess("Email sent - please check your inbox"))
        .catch(() => toastError("We were unable to resend the confirmation link"));
}